import { TransformedCustomViewContainer } from "../../components/transformed_custom_view";
import { PivotControl } from "../../constants/pivot_control_options";
import { defaultConfig } from "./default_config";
import { paramsToTransformArgs } from "./params_to_transform_args";
import { DatePivotParams } from "../../entities/date_pivot_params";
import { createTransferPlanningMatrix } from "./matrix_creator";

export const TransferPlanningContainer = () => {
  return (
    <TransformedCustomViewContainer
      viewControllerConfig={{
        datasetName: "supply_walk_test",
        transformId: "rebalance_opportunities",
        folder: "outputs",
        title: "Transfer Planning",
        dateHierarchyColumnFilter: {},
        excludedSegmentationsFilter: ["location"],
        measureColumnFilter: (params: DatePivotParams) => {
          return {
            "Transfer Opportunity Score": "Transfer Opportunity Score",
            "Source Location": "Source Location",
            "Destination Location": "Destination Location",
            "Transfer Quantity": "Transfer Quantity",
            "Cost Savings": "Cost Savings",
            Distance: "Distance",
          };
        },
        excludedFilterColumnFilter: [],
        showControls: [
          PivotControl.SegmentSelectMulti,
          PivotControl.FilterBy,
          PivotControl.StoreAsDefault,
          PivotControl.Download,
        ],
        paramsToTransformArgs,
        getMatrix: createTransferPlanningMatrix,
      }}
      defaultConfig={defaultConfig}
    />
  );
};
